import { ObjectValues } from 'types/common';

export const ATTRIBUTES_FORM_NAMES = {
  ExcludeBusiness: 'excludeBusiness',
  IncludeGender: 'includeGender',
  IncludeNonDonor: 'includeNonDonor',
  IncludeOutOfStateDonor: 'includeOutOfStateDonor',
} as const;

export type AttributesFormNames = ObjectValues<typeof ATTRIBUTES_FORM_NAMES>;
export const AttributesFormNameKeys = Object.values(ATTRIBUTES_FORM_NAMES);
